module.exports = {
  "id": "04b74e2f-67d7-4ff2-81c3-78fba8b082ac",
  "gtmIds": [
    "GTM-PFPCPB3M"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "gausta",
  "language": "nb-NO",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "nb-NO",
    "en-US"
  ],
  "website": "https://www.gaustablikk.no",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}